/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BroadcastScheduleDto } from '../../models/broadcast-schedule-dto';
import { CursorPaginationDto } from '../../models/cursor-pagination-dto';

export interface BroadcastScheduleControllerSearchCursorV1$Params {

/**
 * 페이지 크기
 */
  pageSize?: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 커서
 */
  cursor?: string;

/**
 * 이벤트 ID
 */
  eventId?: string;

/**
 * 방송 상태
 */
  status?: 'SCHEDULED' | 'SHOOTING_DONE' | 'AIRED' | 'CANCELLED';
}

export function broadcastScheduleControllerSearchCursorV1(http: HttpClient, rootUrl: string, params?: BroadcastScheduleControllerSearchCursorV1$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto & {
'items'?: Array<BroadcastScheduleDto>;
}>> {
  const rb = new RequestBuilder(rootUrl, broadcastScheduleControllerSearchCursorV1.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('cursor', params.cursor, {});
    rb.query('eventId', params.eventId, {});
    rb.query('status', params.status, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CursorPaginationDto & {
      'items'?: Array<BroadcastScheduleDto>;
      }>;
    })
  );
}

broadcastScheduleControllerSearchCursorV1.PATH = '/api/v1/broadcast-schedule/search/cursor';
